import { type VesselMessage } from '../../../../types/VesselMessage';

export const getSupplierSubtextTranslationKey = (
    selectedVessel: VesselMessage | undefined,
    isSpotAllowed: (customerId: string) => boolean
) => {
    if (selectedVessel && isSpotAllowed(selectedVessel.customerId)) {
        return 'order.suppliersubtext';
    }

    return 'order.suppliersubtext.simple';
};
